import React from 'react';
import { useIsFutureEnabled } from '../hooks/useIsFeatureEnabled';
import type { FeatureFlags } from '../config/features';

interface FeatureWrapperProps {
  feature: keyof FeatureFlags;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const FeatureWrapper: React.FC<FeatureWrapperProps> = ({
  feature,
  children,
  fallback = null,
}) => {
  const isEnabled = useIsFutureEnabled(feature);
  return isEnabled ? <>{children}</> : <>{fallback}</>;
};
